import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';
function PMGetAllArchivedTicketsDataService(token,data) {
    return axios.post(`${CURRENT_API_URL}/proactiveMonitoring/PMGetAllArchivedTicketsData`, data, {
     
    headers: {
        'Authorization': token,
      }
    })
    .then(res => {
      notify.NotifySuccess("Archived tickets have been fetched successfully.");
      return res.data;
    })
    .catch(error => {
      console.log(error);
      notify.NotifyError("An error occurred while fetching tickets details. please try again later.");
      return false;
    });
  }
  
  export default PMGetAllArchivedTicketsDataService;
  